import './Approach.scss'
import React from 'react'

const blocks = [
    {
        id: 'technique',
        title: 'Architecture & intégration',
        items: [
            <><strong>Diagnostic</strong> de l’existant et choix d’architecture</>,
            <>Intégration entre vos outils (site, e-commerce, <strong>ERP</strong>, back-office)</>,
            <>Exécution accélérée grâce à l’<strong>IA</strong> sur les tâches répétitives</>,
            <><strong>Performance</strong> web et <strong>SEO</strong> technique</>,
            <><strong>Back-office</strong> et automatisations sur mesure</>,
            <><strong>Déploiement et maintenance</strong></>,
        ],
    },
    {
        id: 'interface',
        title: 'Interface & expérience',
        items: [
            <><strong>UX/UI</strong> pensée pour vos usages réels</>,
            <><strong>Webdesign</strong> et direction artistique</>,
            <><strong>Identité visuelle</strong> et création graphique</>,
            <>Cohérence avec <strong>votre univers</strong></>,
            <>Parcours adaptés à <strong>votre public</strong></>,
            <>Adaptation aux besoins de <strong>vos équipes</strong></>,
        ],
    },
]

function Approach({ only }) {
    const shown = only === undefined
        ? blocks.map((block, index) => [block, index])
        : [[blocks[only], only]]

    return (
        <section
            id={only === undefined || only === 0 ? 'approche' : undefined}
            className="approach"
            aria-label="Approche technique et créative"
        >
            <div className="approach__container">
                <div className="approach__grid">
                    {shown.map(([block, index]) => (
                        <article
                            key={block.id}
                            className={`approach__card approach__card--${index + 1}`}
                            aria-labelledby={`approach-${block.id}-title`}
                        >
                            <div className="approach__card-infoContainer">
                                <h2
                                    id={`approach-${block.id}-title`}
                                    className="approach__card-title"
                                >
                                    {block.title}
                                </h2>

                                <ul className="approach__list">
                                    {block.items.map((item, i) => (
                                        <li key={i}>
                                            <p>{item}</p>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default Approach
